<template>
  <div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <c-table
          ref="table"
          title="유형별 사진 관리 목록"
          :filtering="false"
          :isExcelDown="false"
          tableId="hazardEquipmentTable"
          :columns="grid.columns"
          :data="grid.data"
        >
        </c-table>
        <c-dialog :param="popupOptions"></c-dialog>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'hazard-equipment-type-picture',
  data() {
    return {
      popupOptions: {
        isFull: true,
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
      grid: {
        columns: [
          {
            name: 'codeName',
            field: 'codeName',
            label: '대상품명',
            align: 'left',
            style: 'width:400px',
            sortable: false,
          },
          {
            name: 'attachFile',
            field: 'attachFile',
            label: '관련 사진',
            align: 'center',
            style: 'width:400px',
            type: 'attach',
            taskClassCd: 'HAZARD_EQUIPMENT_PICTURE',
            keyText: 'code',
            sortable: false,
          },
        ],
        data: [],
      },
      editable: true,
      listUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      // api scope
      this.getList();
    },
    getList() {
      this.$comm.getComboItems('HHM_TYPE_CD', null, 'Y').then(_result => {
        this.grid.data = _result;
      });
    },
  }
};
</script>
